import React, { FunctionComponent } from "react";
import { Plan } from "../../../@types";
import { useTranslate } from "../../../helpers";
import { FormattedMessage } from "react-intl-phraseapp";
import PlanRadioInput from "./PlanRadioInput";

const PlanSwitchOptions: FunctionComponent<{
  plans: Plan[];
  selectedPlan: Plan | undefined;
  setSelectedPlan: (plan: Plan) => void;
}> = ({ plans, setSelectedPlan, selectedPlan }) => {
  const t = useTranslate();

  return (
    <div className="mct-hide-print ds-u-margin-bottom--4 ds-u-margin-top--7 ds-u-lg-display--none">
      <div className="ds-u-text-align--center ds-u-border-bottom--1 ds-u-padding-bottom--2">
        <h2 className="ds-u-margin-bottom--2">
          {t("plan_compare.select_a_plan_name")}
        </h2>
        <p className="ds-text-heading--lg ds-u-margin-top--0 ds-u-font-weight--normal">
          <FormattedMessage
            id="plan_compare.you_are_comparing"
            values={{ total: plans.length }}
          />
        </p>
      </div>
      <form className="ds-u-margin-top--6">
        {plans.map(plan => (
          <PlanRadioInput
            plan={plan}
            key={plan.id}
            selectedPlan={selectedPlan}
            setSelectedPlan={setSelectedPlan}
          />
        ))}
      </form>
    </div>
  );
};

export default PlanSwitchOptions;
